import React from "react";
import { useAppSelector } from "store";

import { useTheme, withStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import {
    DataGridPro,
    GridColDef,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid-pro";

import Spacer from "components/Spacer";
import numberFormatter from "utils/numberFormatter";

import { selectIsLoading, selectClassifiedCompetitors } from "modules/customer/tools/location/competitionNew/competitionSlice";

const StyledDataGrid = withStyles(theme => ({
    root: {
        border: 'none',
        backgroundColor: theme.palette.background.paper,
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        '& .MuiCheckbox-root': {
            color: theme.palette.text.primary,
            '&.Mui-checked': {
                //@ts-ignore
                color: theme.palette.tertiary.main,
            },
        },
        '& .MuiDataGrid-row.Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.16)',
            },
        },
        '& .MuiDataGrid-cell:focus': {
            outline: 'none'
        },
        '& .MuiDataGrid-cell:focus-within': {
            outline: 'none'
        }
    }
}))(DataGridPro);

const NearbyCompetitionTable: React.FC = () => {
    const theme = useTheme();
    const isLoading = useAppSelector(selectIsLoading);
    const rows = useAppSelector(selectClassifiedCompetitors);
    const columns: GridColDef[] = [
        {
            field: 'storeName',
            flex: 1,
            headerName: 'Store name',
            sortable: true,
        },
        {
            field: 'brandName',
            flex: 1,
            headerName: 'Brand name',
            sortable: true,
            hide: true
        },
        {
            field: 'distanceToSelectedLocation',
            type: 'number',
            flex: 1,
            headerName: 'Distance from selected Location',
            sortable: true,
            renderCell: (params) => numberFormatter.toDecimalPlaces(params.value ?? 0, 1) + " km"
        },
        {
            field: 'displayCategoryName',
            flex: 1,
            headerName: 'Store category',
            sortable: true,
        },
        {
            field: 'alternateCategoryNames',
            flex: 1,
            headerName: 'Alternate store categories',
            sortable: true
        },
        {
            field: 'sizeLabel',
            flex: 1,
            headerName: 'Store size',
            sortable: true
        }
    ];

    const columndsWithWidth = columns.map(column => {
        if (column.type === 'singleSelect') {
            //@ts-expect-error
            column.valueOptions = Array.from(new Set(rows.map(row => row[column.field])));
        }
        return {
            ...column,
            minWidth: 200
        };
    });

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ paddingRight: theme.spacing(2) }}>
                <GridToolbarColumnsButton style={{ color: theme.palette.text.primary }} />
                <GridToolbarFilterButton style={{ color: theme.palette.text.primary }} />
                <Spacer />
                {/* @ts-ignore */}
                <GridToolbarExport style={{ color: theme.palette.tertiary.main }} />
            </GridToolbarContainer>
        );
    }

    return (
        <StyledDataGrid
            rows={rows}
            columns={columndsWithWidth}
            checkboxSelection
            disableSelectionOnClick
            loading={isLoading}
            components={{
                Toolbar: CustomToolbar,
                ColumnSortedAscendingIcon: ExpandLess,
                ColumnSortedDescendingIcon: ExpandMore
            }}
            sortingOrder={['asc', 'desc']}
            hideFooter
        />
    );
};

export default NearbyCompetitionTable;
